/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

module.exports = function(){ /* empty */ };



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/$.add-to-unscopables.js
 ** module id = 1328
 ** module chunks = 0
 **/